var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEnso = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6715 28.7437H24.1075V14.8355C24.1075 13.5839 23.868 12.3788 23.3895 11.2192C22.9103 10.1219 22.2459 9.14113 21.3954 8.2754C20.5297 7.42573 19.5489 6.76124 18.4516 6.28205C17.2928 5.80292 16.0876 5.5633 14.8354 5.5633C13.5839 5.5633 12.378 5.80292 11.2199 6.28205C10.1067 6.76124 9.12519 7.42573 8.27615 8.2754C7.42566 9.14112 6.76119 10.1219 6.28203 11.2192C5.80286 12.3788 5.564 13.5839 5.564 14.8355V28.7437H0V14.8355C0 12.8268 0.38579 10.9029 1.15956 9.06367C1.91595 7.28669 2.9749 5.71022 4.33496 4.33503C5.71022 2.97492 7.28669 1.9167 9.06367 1.15961C10.9029 0.38654 12.8268 0 14.8354 0C16.8447 0 18.7687 0.38654 20.6079 1.15961C22.3848 1.91669 23.9606 2.97492 25.3366 4.33503C26.6966 5.71021 27.7549 7.28669 28.512 9.06367C29.285 10.9029 29.6715 12.8268 29.6715 14.8355V28.7437Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7331,
    cy: 20.0007,
    r: 3.57294
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.6715,
    height: 28.7437,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.6715,
    height: 28.7437,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.6715,
    height: 28.7437,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnso, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Enso.6a24a7f7.svg";
export { ForwardRef as ReactComponent };